<template>
  <el-dialog
    :title="tipParmas.title"
    width="30%"
    :before-close="handleClose"
    :visible.sync="tipParmas.tipsVisible"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <el-alert
      title="本场考试答题规则，请仔细阅读！"
      type="info"
      show-icon
      :closable="false"
    />
    <div class="content" v-html=" tipParmas.tipsContent" />
    <span slot="footer" class="dialog-footer">
      <span v-if="btnDisabled" class="time">{{ time }}s</span>
      <el-button v-if="btnDisabled" :disabled="btnDisabled" class="dis_btn" size="small">我已知晓</el-button>
      <el-button v-else type="primary" size="small" @click="know">我已知晓</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    tipParmas: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
      btnDisabled: true,
      time: 5
    }
  },
  watch: {
    'tipParmas.tipsVisible': {
      handler(val) {
        if (val) {
          if (this.tipParmas.showTime) {
            const timer = setInterval(() => {
              this.time--;
              if (this.time == 0) {
                this.btnDisabled = false
                clearInterval(timer)
              }
            }, 1000);
          } else {
            this.btnDisabled = false
          }
        }
      },
      deep: true,
      immediate: true // 第一次初始化渲染就可以监听到
    }
  },
  methods: {
    handleClose() {
      this.btnDisabled = true;
      this.time = 5
      this.$emit('know', this.tipParmas.special ? 3 : 1)
    },
    know() {
      this.$emit('know', this.tipParmas.special ? 3 : 1)
    }
  }
}
</script>
  <style lang="scss" scoped>
.content{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #606060;
    line-height: 24px;
    padding: 10px 24px 16px 24px;
}
.dis_btn{
  background: #F7F8FA;
  border: none;
}
.time{
  font-size: 14px;
  color: #DD594A;
  margin-right: 8px;
}
::v-deep {
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog__body{
    padding: 0;
  }
  .el-alert--info.is-light{
    background-color: #FFF3F0;
    color: #EB5C55;
    position: relative !important;
    top: 0 !important;
  }
}
  </style>

